import {ReactNode} from 'react';

interface MenuGroupProps {
  children: ReactNode;
}

export const MenuGroup = ({children}: MenuGroupProps) => (
  <div className="group/menu-group flex flex-col gap-px">
    {children}
    <div className="mx-1 my-0.5 h-px bg-border-primary/50 group-last/menu-group:hidden" />
  </div>
);
